module.exports = __webpack_public_path__ + "static/media/Process_flow_dark_background_v2.512fd106.png";